module.exports = __webpack_public_path__ + "02_very_short_yellow.f99169c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_very_short_yellow.png
// module id = kE4H
// module chunks = 0